module.exports = __webpack_public_path__ + "static/media/efghij_3bhk.435ad49a.jpg";